import React, { useState, useEffect } from "react";
import ListItem from "@mui/material/List";
import { Link } from "react-scroll";
import "./style.css";
import { useLocation } from "react-router-dom";
import AOS from "aos";
import menus from "../../api/menus";

const MobileMenu = () => {
  const [openId] = useState(0);
  const [menuActive, setMenuState] = useState(false);

  const location = useLocation();

  const isHome = location.pathname === "/";

  useEffect(() => {
    AOS.init({
      offset: 200,
      duration: 1000,
      easing: "ease-in-sine",
      delay: 500,
      once: false,
    });
  }, []);

  return (
    <div>
      <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
        <div className="menu-close">
          <div className="clox" onClick={() => setMenuState(!menuActive)}>
            <i className="ti-close"></i>
          </div>
        </div>

        <ul className="responsivemenu">
          {menus.map((item, mn) => {
            return (
              <ListItem
                className={item.id === openId ? "active" : null}
                key={mn}
              >
                {isHome ? (
                  <Link
                    activeClass="active"
                    className="active"
                    spy={true}
                    smooth={true}
                    offset={item.offset}
                    duration={500}
                    to={item.link}
                  >
                    {item.title}
                  </Link>
                ) : (
                  <a href="/" rel="noreferrer" className="active">
                    {item.title}
                  </a>
                )}
              </ListItem>
            );
          })}
        </ul>
      </div>

      <div
        className="showmenu mobail-menu"
        onClick={() => setMenuState(!menuActive)}
      >
        <button
          type="button"
          className="navbar-toggler open-btn"
          aria-label="Tombol Menu"
          data-aos="fade-right"
        >
          <span className="icon-bar first-angle"></span>
          <span className="icon-bar middle-angle"></span>
          <span className="icon-bar last-angle"></span>
        </button>
      </div>
    </div>
  );
};

export default MobileMenu;
